

export default class Alerts {
    public static Throw = (content: string, style: AlertType, closable: boolean = false, time?: number) => {
        let alert = document.createElement('div');

        // Classes
        alert.classList.add('pol-alert');
        alert.classList.add(style);

        // Set closable or automatic close
        if (closable) {
            alert.innerHTML = '<i class="fa fa-times-circle"></i>' +  content;
            alert.getElementsByClassName('fa-times-circle')[0].addEventListener('click', () => {
                alert.classList.remove('show');
                setTimeout(() => {
                    alert.remove();
                }, 500);                
            });
        }
        else {
            alert.innerHTML = content;

            setTimeout(() => {
                alert.classList.remove('show');

                setTimeout(() => {
                    alert.remove();
                }, 100);                
            }, time);
        }

        // Append and show     
        document.body.appendChild(alert);
        setTimeout(() => {
            alert.classList.add('show');
        }, 100);        
    }
}

export enum AlertType {
    Danger = 'danger',
    Info = 'info',
    Success = 'success',
    Warning = 'warning'
}